import { ENDPOINT } from "../configs/api";
import { httpClient } from "./httpClient";
import { Token } from "../types/auth";
import { RequestResponse } from "../types/httpClient";

export async function studentLogin(username: string, code: string): Promise<Token> {
    const response: RequestResponse = await httpClient.post(ENDPOINT.iclass.studentLogin, { username, code }, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });

    if (response.data.code > 0) {
        throw new Error(response.data.error_code);
    }

    return {
        access_token: response?.data?.results?.access_token,
        refresh_token: response?.data?.results?.refresh_token,
        expires_in: response?.data?.results?.expires_in
    }
}

export async function teacherLogin(googleToken: string): Promise<Token> {
    const response: RequestResponse = await httpClient.post(ENDPOINT.iclass.teacherLogin, { token: googleToken }, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })

    if (response.data.code > 0) {
        throw new Error(response.data.error_code);
    }

    return {
        access_token: response?.data?.results?.access_token,
        refresh_token: response?.data?.results?.refresh_token,
        expires_in: response?.data?.results?.expires_in
    }
}